module.exports = __webpack_public_path__ + "static/media/park.85ebae4d.svg";